import { useEffect, useState } from "react";
import CustomersService from "../../../../../../../services/customers";

export const useLoadData = (customerId: string | undefined) => {
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [data, setData] = useState<any[]>([]);

  const [total, setTotal] = useState<number>(0);

  useEffect(() => {
    if (customerId) {
      setIsLoading(true);

      const request = {
        pageNumber: 1,
        pageSize: 100000,
        parentId: customerId,
      };

      CustomersService.fetchCustomerAccounts(request)
        .then((res: any) => {
          setIsLoading(false);
          setData(res.map((item: any, i: number) => ({ ...item, i })));
          setTotal(res.length);
        })
        .catch(() => {
          setIsLoading(false);
        });
    }
  }, [customerId]);

  return { data, total, isLoading };
};
